import { render } from "./Mail.vue?vue&type=template&id=840cc84a&scoped=true&ts=true"
import script from "./Mail.vue?vue&type=script&lang=ts"
export * from "./Mail.vue?vue&type=script&lang=ts"

import "./Mail.vue?vue&type=style&index=0&id=840cc84a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840cc84a"]])

export default __exports__